module.exports = __webpack_public_path__ + "static/media/users.87e326e2.svg";